<template>
  <IntegrationSettingsMenu
    name="Slack"
    :features="features"
    :preferences="preferences"
    :integration="integration.value"
  >
    <!-- SLOT INSTALLATION STEPS -->
    <IntegrationSettingsStep
      name="1"
      :title="$t('settings.integration.slack.title')"
      :success="state.success"
    />
    <div class="step-container">
      <div class="step-item">
        <div class="step-text">
          {{ $t('settings.integration.slack.todo') }}
        </div>
        <div class="step-text" @click="initSlackAuth()">
          <img
            class="my-2 pointer"
            :class="['my-2', 'pointer', { disabled: state.success }]"
            alt="Add to Slack"
            height="40"
            width="139"
            src="https://platform.slack-edge.com/img/add_to_slack.png"
            srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
          />
        </div>
        <div class="step-text">
          {{ $t('settings.integration.slack.finished') }}
        </div>
      </div>
    </div>
  </IntegrationSettingsMenu>
</template>

<script>
import { mapActions } from 'vuex';
import IntegrationSettingsStep from '@/components/Settings/IntegrationSettings/Integrations/IntegrationSettingsStep';
import IntegrationSettingsMenu from '@/components/Settings/IntegrationSettings/Integrations/IntegrationSettingsMenu';

export default {
  name: 'integration-settings-slack',
  components: {
    IntegrationSettingsStep,
    IntegrationSettingsMenu,
  },
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    const { slack_success } = this.$route.query;
    if (slack_success) {
      this.statusMessage(slack_success === 'true');
    }

    this.state.success = await this.checkAuthExists('slack');
  },
  computed: {
    features() {
      return this.integration.features;
    },
  },
  data() {
    return {
      preferences: {},
      state: {
        success: false,
      },
    };
  },
  methods: {
    ...mapActions(['getOauthInitUrl', 'checkAuthExists', 'deleteAuth']),
    async initSlackAuth() {
      if (this.state.success) return;

      const url = await this.getOauthInitUrl('slack');
      if (url) return window.open(url, '_blank');

      this.statusMessage('error');
    },
    statusMessage(success) {
      this.$message({
        message: this.$t(
          `settings.integration.${success ? 'success' : 'error'}`,
          { integration: 'Slack' },
        ),
        type: success ? 'success' : 'error',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  .pointer {
    pointer-events: none;
  }
}
.step-container {
  padding-left: 38px;

  .step-item {
    color: $grey-6-mayday;
    font-size: 12px;
    margin-bottom: 10px;
    .step-action {
      display: flex;
      button {
        margin-left: 1rem;
      }
    }
    :deep() .el-input__inner {
      height: 34px;
    }
    ol {
      padding-left: 12px;
    }
    .step-info {
      border: 1px solid $grey-5-mayday;
      background-color: $grey-1-mayday;
      color: $grey-8-mayday;
      padding: 6px 10px;
      margin: 0;
      p {
        font-size: 12px;
        margin-bottom: 0;
        font-weight: bold;
      }
    }
    .step-input {
      margin-bottom: 10px;
      .label {
        font-weight: bold;
        color: black;
        padding: 8px 0px;
      }
      .step-input-icon {
        width: 16px;
        height: 16px;
        margin: 9px 4px;
      }
      .description {
        font-size: 12px;
        color: black;
      }
    }
  }
}
</style>
